import React, { useEffect, useRef, useState } from 'react';
import { SearchBar } from 'src/components/Affiliate/SearchSection/SearchBar';
import { Typography } from '@guildeducationinc/recess';
import { AcademicPartnerHit } from 'src/queries/user';
import { ResultCount } from 'src/components/Affiliate/SearchSection/ResultCount';
import { ResultsPagination } from 'src/components/Affiliate/SearchSection/CustomPagination';
import { SearchResults } from 'src/components/Affiliate/SearchSection/SearchResults';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import styles from './SearchSection.module.scss';

export const SearchSection: React.FC = () => {
	const [hits, setHits] = useState<AcademicPartnerHit[]>();
	const [query, setQuery] = useState<string>('');
	const [page, setPage] = useState<number>(1);

	const { location } = useHistory();
	const resultsRef = useRef<HTMLDivElement>(null);

	const beginningIndexOfPaginatedResults = (page - 1) * 10;
	const endingIndexOfPaginatedResults = page * 10;

	const hitsToShow =
		hits?.slice(beginningIndexOfPaginatedResults, endingIndexOfPaginatedResults) || [];
	const totalCount = hits?.length;
	const totalPage = totalCount ? Math.ceil(totalCount / 10) : 1;

	useEffect(() => {
		if (page > totalPage) {
			setPage(1);
		}
	}, [totalPage, page]);

	useEffect(() => {
		if (resultsRef.current) {
			const query = qs.parse(location.search.slice(1));
			if (query?.affiliateName) {
				setQuery(query.affiliateName.toString());
				resultsRef.current.scrollIntoView({ behavior: 'smooth' });
			}
		}
	}, [location.search, resultsRef]);

	return (
		<div className={styles.searchSectionContainer}>
			<Typography variant='h2'>Direct Payment Program schools</Typography>
			<SearchBar query={query} setHits={setHits} setQuery={setQuery} />
			<div className={styles.searchResultsContainer} ref={resultsRef}>
				<ResultCount count={hits?.length || 0} query={query} />
				<SearchResults hits={hitsToShow} />
				<ResultsPagination
					page={page}
					setPageNumber={setPage}
					totalCount={totalCount}
					totalPages={totalPage}
				/>
			</div>
		</div>
	);
};
